import React from "react";
import { Box, Stack, Typography, Button, Card, CardContent } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import NewColors from "../../themes/NewColors";

const SubscriptionTierCard = ({
  tier,
  price,
  features,
  isCurrentTier = false,
  isPopular = false,
  onSubscribe,
  loading = false,
  isActiveSubscription = false,
}) => {
  const getTierColor = () => {
    if (isPopular) return NewColors.brand.primary;
    if (tier === "pro") return NewColors.charts.purple;
    if (tier === "standard") return NewColors.charts.blue;
    return NewColors.border.medium;
  };

  const getTierName = () => {
    if (tier === "pro") return "Pro";
    if (tier === "standard") return "Standard";
    return "Free";
  };

  return (
    <Card
      sx={{
        position: "relative",
        border: isPopular ? `2px solid ${getTierColor()}` : "1px solid",
        borderColor: isPopular ? getTierColor() : NewColors.border.medium,
        borderRadius: 2,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        transition: "transform 0.2s, box-shadow 0.2s",
        overflow: "visible",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: 4,
        },
      }}
    >
      {isPopular && (
        <Box
          sx={{
            position: "absolute",
            top: -10,
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: getTierColor(),
            color: "white",
            padding: "4px 16px",
            borderRadius: 1,
            fontSize: "0.75rem",
            fontWeight: "bold",
            zIndex: 1,
            whiteSpace: "nowrap",
          }}
        >
          MOST POPULAR
        </Box>
      )}

      <CardContent
        sx={{
          flexGrow: 1,
          padding: 3,
          paddingTop: isPopular ? 4 : 3,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack spacing={2} sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
          <Typography variant="h5" fontWeight="bold">
            {getTierName()}
          </Typography>

          <Box>
            <Typography variant="h3" fontWeight="bold" color={getTierColor()}>
              ${price}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              per month
            </Typography>
          </Box>

          <Stack spacing={1.5} sx={{ flexGrow: 1 }}>
            {features.map((feature, index) => (
              <Stack
                key={index}
                direction="row"
                spacing={1}
                alignItems="flex-start"
              >
                <CheckCircleIcon
                  sx={{
                    color: getTierColor(),
                    fontSize: 20,
                    marginTop: 0.5,
                    flexShrink: 0,
                  }}
                />
                <Typography variant="body2">{feature}</Typography>
              </Stack>
            ))}
          </Stack>

          <Button
            variant={isPopular ? "contained" : "outlined"}
            fullWidth
            size="large"
            onClick={onSubscribe}
            disabled={isCurrentTier || loading}
            sx={{
              marginTop: "auto",
              backgroundColor: isPopular ? getTierColor() : "transparent",
              color: isPopular ? "white" : getTierColor(),
              borderColor: getTierColor(),
              "&:hover": {
                backgroundColor: isPopular ? getTierColor() : getTierColor(),
                color: "white",
              },
            }}
          >
            {isCurrentTier
              ? "Current Plan"
              : loading
                ? "Loading..."
                : isActiveSubscription
                  ? tier === "free"
                    ? "Cancel Subscription"
                    : `Switch to ${getTierName()}`
                  : tier === "free"
                    ? "Get Started"
                    : "Subscribe"}
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default SubscriptionTierCard;
